import { useLocation } from 'react-router-dom';
import { apis } from '../constants';
import { _getVanillan, _post, del, get, post, postFormDataWithoutHeaders } from './fetchHelper';

export const useBackendApi = () => {
  const location = useLocation();
  // paths are not being resolved by useParams where context is not inside route components
  const communityName = location.pathname.split('/')?.[1];

  const cacheRequest = async (storageId, api, expireMillis = 6 * 60 * 60 * 1000, resetCache) => {
    let cache = JSON.parse(localStorage.getItem(storageId));
    const currentTime = Date.now();
    if (!cache?.data || cache?.expireAt < currentTime || resetCache) {
      cache = { data: await api() };
      cache.expireAt = currentTime + expireMillis;
      localStorage.setItem(storageId, JSON.stringify(cache));
    }
    return cache.data;
  };

  return {
    login: async body => post(apis.backend.login(), body),
    logout: async () => _post(apis.backend.logout()),
    refreshAccessToken: async () => post(apis.backend.refreshAccessToken()),
    getAccessTokenForWallet: async body => _post(apis.backend.login(), body),
    getCookies: async body => post(apis.backend.loginGetCookies(), body),
    getLoginState: async body => post(apis.backend.getLoginState(), body),

    getAllBanners: async () => cacheRequest('banner', () => get(apis.backend.get_allBanners())),
    getAnalyticsData: async body => post(apis.backend.getAnalyticsData(), body),

    user: {
      getIdentityClaims: async () => get(apis.backend.getUserIdentityClaims()),
      disconnectAccount: async body => post(apis.backend.disconnectAccount(), body),
      getUserActivity: async () => get(apis.backend.getUserActivity()),
      setUserName: async body => post(apis.backend.setUserName(), body),
      checkUserName: async username => get(apis.backend.checkUserName(username)),
      updateUserMetadata: async body => postFormDataWithoutHeaders(apis.backend.updateUserMetadata(), body),
      spectateUser: async address => get(apis.backend.spectateUser(address)),
    },
    oauth: {
      twitterLogin: postLoginRedirectUrl => get(apis.backend.twitterLogin(postLoginRedirectUrl)),
      twitterCallback: () => get(apis.backend.twitterLoginCallback()),
    },

    mrep: {
      getProtocolWiseMrepData: async body => post(apis.backend.getProtocolWiseMrepData(), body),
      getChainWiseMrepData: async body => post(apis.backend.getChainWiseMrepData(), body),
      getAllProtocols: async () => get(apis.backend.getAllProtocols()),
      getAllChains: async () => get(apis.backend.getAllChains()),
      getActionStats: async body => post(apis.backend.getActionStats(), body),
      getProtocolData: async protocol => get(apis.backend.getProtocolData(protocol)),
      getChainMetadata: async chainId => get(apis.backend.getChainMetadata(chainId)),
      getProtocolPositioning: async body => post(apis.backend.getProtocolPositioning(), body),
      compareRanking: async body => post(apis.backend.compareRanking(), body),
      chainCompareRanking: async body => post(apis.backend.chainComapareRanking(), body),
    },
    humanEd: {
      getWhitelistStats: () => get(apis.backend.getWhitlistStats()),
      postVerificationVideo: body => postFormDataWithoutHeaders(apis.backend.postVerificationVideo(), body),
      getVideoToken: () => get(apis.backend.getVideoToken()),
    },
    reviews: {
      postReview: body => postFormDataWithoutHeaders(apis.backend.handleReview(), body),
      getFeed: body => post(apis.backend.getMainFeedV2(), body),
      postReaction: body => post(apis.backend.postReaction(), body),
      postSeen: body => post(apis.backend.postSeen(), body),
      leaderboard: () => get(apis.backend.reviewLeaderboard()),
      eligibileProtocols: () => get(apis.backend.eligibileProtocols()),
      protocolRating: project => get(apis.backend.protocolRating(project)),
      useMegaCode: () => get(apis.backend.useMegaCode()),
      postMegaCode: body => post(apis.backend.postMegaCode(), body),
      getReviewdProtocol: () => get(apis.backend.reviewedProtocol()),
      getUserPosts: body => get(apis.backend.getUserPosts(body)),
      classifiedProtocolRating: () => get(apis.backend.classifiedProtocolRating()),
      userProtocolStatsWithRating: () => get(apis.backend.userProtocolStatsWithRating()),
      postComment: body => postFormDataWithoutHeaders(apis.backend.postComment(), body),
      protocolAdmins: () => get(apis.backend.protocolsAdmin()),
      deleteComment: commendId => del(apis.backend.deleteComment(commendId)),
      puzzleCodeStats: () => get(apis.backend.puzzleCodeStats()),
      postPuzzleCode: body => post(apis.backend.postPuzzleCode(), body),
      getUserCodes: () => get(apis.backend.userCodes()),
      spinsUsed: () => get(apis.backend.spinsUsed()),
      createInviteCodes: () => post(apis.backend.createInviteCodes()),
      randomTwitterCodeUser: () => get(apis.backend.randomTwitterCodeUser()),
      getAirdropAndRankingData: protocol => get(apis.backend.getAirdropAndRankingData(protocol)),
      getAllReviewsTag: () => get(apis.backend.getAllReviewsTag()),
      getReviewTagsWithReviews: (protocol) => get(apis.backend.getReviewTagsWithReviews(protocol)),
      getReactionEligible: () => get(apis.backend.getReactionEligible()),
    },
  };
};

export const useGelatoApi = () => {
  return {
    getTxn: taskId => _getVanillan(apis.gelato.getTxn(taskId)),
  };
};
